







import { Component, Vue } from 'vue-property-decorator';
import BaseSnackbar from '@/components/BaseSnackbar.vue';

@Component({
  components: {
    BaseSnackbar,
  },
})
export default class App extends Vue {}
